/**
 * API client for the Analytics Cockpit endpoint.
 */

import api from './client';
import { API_BASE_URL } from '@/config';
import type { CockpitPayload } from '@/types/cockpit';

export interface CockpitQueryParams {
  snapshotId?: string | null;
  baselineId?: string | null;
  wbs?: string[];
  activityCode?: string[];
  status?: string[];
}

/**
 * Fetch the full cockpit payload for a project.
 */
export async function getCockpitSummary(
  projectId: string,
  params: CockpitQueryParams = {},
): Promise<CockpitPayload> {
  const qp = new URLSearchParams();
  if (params.snapshotId) qp.set('snapshot_id', params.snapshotId);
  if (params.baselineId) qp.set('baseline_id', params.baselineId);
  if (params.wbs?.length) qp.set('wbs', params.wbs.join(','));
  if (params.activityCode?.length) qp.set('activityCode', params.activityCode.join(','));
  if (params.status?.length) qp.set('status', params.status.join(','));

  const qs = qp.toString();
  const url = `${API_BASE_URL}/v1/analytics/cockpit/${projectId}${qs ? `?${qs}` : ''}`;
  const response = await api.get(url);
  return response.data as CockpitPayload;
}
